<div class="modal-container">
  <button
    id="modalEditar"
    #modalEditar
    data-bs-toggle="modal"
    data-bs-target="#modelND"
    hidden="hidden">
    Launch
  </button>
  <div
    class="modal fade"
    id="modelND"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title h5-tipografia-govco">Cambiar archivo</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="text-center" *ngIf="docuemtalInfoRegister?.DatasetId">
            <div class="no-data-container">
              <p style="color: green">
                Archivo actual:
                {{ docuemtalInfoRegister?.FileName }}
              </p>
            </div>
          </div>
          <!-- Registrar nuevo documento -->
          <div
            class="upload-container mt-3"
            [class.dragging]="isDragging"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)">
            <h5>Nuevo archivo</h5>
            <div class="upload-box">
              <label for="fileUpload">
                <span class="upload-icon">⬆</span>
                <br />
                Arrastre el archivo .pdf
              </label>
              <input
                id="fileUpload"
                type="file"
                class="file-input"
                accept=".pdf"
                (change)="onFileSelected($event)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
